import React from "react";
import { View } from "react-native";
import ItemOptions from "../ItemOptions";
import RemoveItem from "./RemoveItem";
import { editIndividualStyles as styles } from "./styles";
import { Product } from "@/app/types/product";
import { OptionsType } from "@/app/types/option";
import AboutProduct from "./AboutProduct";

type EditIndividualProps = {
  lineItemId: string;
  variationItem: Product;
  currentLineOptions: OptionsType[];
  onDeletePress: () => void;
};

const EditIndividual = ({
  lineItemId,
  variationItem,
  currentLineOptions,
  onDeletePress,
}: EditIndividualProps): JSX.Element => {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <View style={styles.aboutContainer}>
          <AboutProduct item={variationItem} />
        </View>
        <RemoveItem onDeletePress={onDeletePress} />
      </View>
      <View style={styles.bottomContainer}>
        <ItemOptions
          lineItemId={Number(lineItemId)}
          defaultOptions={currentLineOptions}
        />
      </View>
    </View>
  );
};

export default EditIndividual;
